import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Routes where ads should never appear (no publisher content)
const NO_AD_ROUTES = [
  "/auth",
  "/dashboard",
  "/profile",
  "/user-profile",
  "/courses/add",
];

const NO_AD_PREFIXES = ["/course/update/"];

/**
 * AdSenseGuard — pauses auto-ads on routes with no publisher content.
 * Place this inside <BrowserRouter> so it has access to useLocation.
 */
const AdSenseGuard = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isNoAdPage =
      NO_AD_ROUTES.includes(pathname) ||
      NO_AD_PREFIXES.some((prefix) => pathname.startsWith(prefix));

    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.pauseAdRequests = isNoAdPage ? 1 : 0;
  }, [pathname]);

  return null;
};

export default AdSenseGuard;
